<div class="mainpanel">
    <mat-toolbar color="primary">
        <h2 class="mat-title">Nominee Finalization Tool</h2>
    </mat-toolbar>

    <p class="top">
        Listed below are the nominees for this year's award along with the current judging status for each nominee.
        Please note that this list is calculated in real time if an active judging window is open.
        Once the selected judging window is closed, you will be able to review the standings and finalize the results.
        If a judging phase has a tie among two or more nominees in their respective category, you will be prompted to schedule a tie-breaking round in the system.
    </p>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <mat-form-field>
            <mat-label>Select Phase</mat-label>
            <mat-select [(ngModel)]="SelectedPhase">
                <mat-option *ngFor="let p of Phases" [value]="p.Value">{{p.Display}}</mat-option>
            </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="RetrieveScores()" [disabled]="SelectedPhase < 1">Retrieve Scores</button>
    </div>

    <p *ngIf="NoResults">No results were found</p>
    <div *ngIf="ViewReady && !NoResults" class="bottomMargin">
        <div fxLayout="row" fxLayoutAlign="start start" class="tabs">
            <div *ngFor="let nom of PhaseScores; let nomIndex = index" class="customtab" [class.active]="NominationIndex === nomIndex" (click)="ChangeNomination(nomIndex)">
                <mat-icon *ngIf="!NominationComplete(nom)" class="redicon">report_problem</mat-icon>
                <mat-icon *ngIf="NominationComplete(nom)" class="greenicon">done</mat-icon>
                <span>{{GetNomName(nom?.NomineeTypeID)}}</span>
            </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px" class="top" *ngIf="PhaseScores[NominationIndex]?.JudgingPhase < 3">
            <button class="DistrictButton" mat-raised-button *ngFor="let d of PhaseScores[NominationIndex]?.DistrictList; let distIndex = index" [class.active]="DistrictIndex === distIndex" (click)="ChangeDistrict(distIndex)">
                <mat-icon *ngIf="!d?.WinnerFinalized" class="redicon">report_problem</mat-icon>
                <mat-icon *ngIf="d?.WinnerFinalized" class="greenicon">done</mat-icon>
                <span>{{d?.BoardDistrict}}</span>
            </button>
        </div>

        <div>
            <table>
                <thead class="primarybackground500">
                    <tr>
                        <th>Nominee #</th>
                        <th *ngIf="Employee">SAPID</th>
                        <th>Name</th>
                        <th *ngIf="Employee">Title</th>
                        <th>Site #</th>
                        <th>Site Name</th>
                        <th>Final Score</th>
                        <th>Final Rank</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let s of PhaseScores[NominationIndex]?.DistrictList[DistrictIndex]?.Scores; let i = index">
                        <tr [class.unfinalizedWinner]="s?.FinalRank === 1" [class.finalizedWinner]="s?.FinalizedWinner">
                            <td><mat-icon *ngIf="s?.FinalizedWinner">emoji_events</mat-icon>{{s?.NominationID}}</td>
                            <td *ngIf="Employee">{{s?.SAPID}}</td>
                            <td>{{s?.FirstName}} {{s?.LastName}}</td>
                            <td *ngIf="Employee">{{s?.LocalJobTitle}}</td>
                            <td>{{s?.SiteLocation}}</td>
                            <td>{{s?.SiteName}}</td>
                            <td>{{s?.FinalScore}}</td>
                            <td>{{s?.FinalRank}}</td>
                            <td>
                                <button *ngIf="s.Details != null && s.Details.length > 0" mat-raised-button color="primary" (click)="ViewDetails(i)" class="actions">
                                    <span *ngIf="!s?.DetailsShown">View</span><span *ngIf="s?.DetailsShown">Hide</span> Details
                                </button>
                                <button *ngIf="s.FinalRank === 1 && !s.WinnerTie && !s.FinalizedWinner" mat-raised-button color="primary" (click)="FinalizeWinner(s)" class="actions">
                                    <span>Finalize </span>
                                    <span *ngIf="PhaseScores[NominationIndex]?.JudgingPhase < 3">District {{PhaseScores[NominationIndex]?.DistrictList[DistrictIndex]?.BoardDistrict}}</span>
                                    <span *ngIf="PhaseScores[NominationIndex]?.JudgingPhase > 2">Nomination</span>
                                    <span> Winner</span>
                                </button>
                                <button *ngIf="(s.JudgingPhase === 1 || s.JudgingPhase === 3) && s.WinnerTie && !s.FinalizedWinner" mat-raised-button color="primary" (click)="StartTieBreaker()" class="actions">
                                    Start Tie-Breaker Round
                                </button>
                                <button *ngIf="(s.JudgingPhase === 2 || s.JudgingPhase === 4) && s.WinnerTie && !s.FinalizedWinner" mat-raised-button color="primary" (click)="OverrideTie()" class="actions">
                                    Override Tie
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="s?.DetailsShown">
                            <td colspan="9" class="details">
                                <h2>Scoring Details</h2>
                                <table>
                                    <thead class="primarybackground500">
                                        <tr>
                                            <th>Judge #</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let d of s.Details">
                                            <td>{{d.JudgeID}}</td>
                                            <td>{{d.FirstName}} {{d.LastName}}</td>
                                            <td>{{d.Email}}</td>
                                            <td>{{d.JudgeScore}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
